import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ExternalLink, Users } from 'lucide-react';
import { useLang } from '@/contexts/LangContext';
import { useIsMobile } from '@/hooks/use-mobile';

const HeroSection = () => {
  const { t } = useLang();
  const isMobile = useIsMobile();
  
  return (
    <div className="max-w-3xl mx-auto text-center mb-8">
      <div className="mb-8">
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white px-4 sm:px-6 py-3 rounded-full shadow-lg inline-flex items-center mx-auto">
          <span className="animate-pulse mr-2">🔥</span>
          <span className="font-semibold mr-2">{t.promo.signUp}</span>
          <span className="font-bold text-yellow-300">{t.promo.months}</span>
          <span className={`text-xs ml-2 opacity-80 ${isMobile ? 'hidden sm:inline' : ''}`}>{t.promo.worth}</span>
        </div>
        <div className="mt-2">
          <div className="bg-red-600 text-white px-4 py-1 rounded-full text-xs inline-flex items-center">
            <span>{t.promo.limitedTime}</span>
          </div>
        </div>
      </div>
      
      <div className="flex justify-center mb-8">
        <img 
          src="/lovable-uploads/9374987f-70d0-4ef3-a74d-deada4d71a29.png" 
          alt="OKX Logo" 
          className="h-14 md:h-16 filter brightness-0 invert"
        />
      </div>
      <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-white relative z-10" 
        style={{ color: '#2fb8f8' }}
        dangerouslySetInnerHTML={{ __html: t.hero.title }}></h1>
      <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-6">
        {t.hero.subtitle}
      </p>
      
      <div className="flex items-center justify-center mb-8 text-gray-300 bg-gray-800/50 py-3 px-4 rounded-full mx-auto max-w-max">
        <Users className="mr-2 text-blue-400" size={18} />
        <p className="text-sm">{t.hero.socialProof}</p>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/signup?campaign=okx">
          <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-lg shadow-[0_0_15px_rgba(37,99,235,0.5)]">
            {t.hero.signUpForFree} <ArrowRight className="ml-2" />
          </Button>
        </Link>
        <a 
          href="https://www.okx.com/join" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <Button 
            variant="outline" 
            className="border-gray-800 bg-gray-800 hover:bg-gray-700 text-white px-8 py-6 text-lg rounded-lg"
          >
            {t.hero.learnMore} <ExternalLink className="ml-2" />
          </Button>
        </a>
      </div>
      <div className="text-center mt-6">
        <p className="text-sm text-gray-500 mb-2">{t.hero.poweredBy}</p>
        <img 
          src="/lovable-uploads/f53d41d9-df84-4116-9417-3c17a57c3768.png" 
          alt="METRADE Logo" 
          className="h-8 mx-auto"
        />
      </div>
    </div>
  );
};

export default HeroSection;
